module.exports = __webpack_public_path__ + "static/media/not_found_media.e95048c4.png";